import { jsx as _jsx } from "react/jsx-runtime";
const ChevronDown = props => (_jsx("svg", { width: "10px", height: "6px", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 10 6", ...props, children: _jsx("path", { d: "M.2.2c.3-.3.9-.3 1.2 0L5 3.8 8.6.2c.3-.3.9-.3 1.2 0 .3.3.3.9 0 1.2L5.6 5.6c-.3.3-.9.3-1.2 0L.2 1.4C.1 1.3 0 1 0 .8 0 .6.1.4.2.2z" }) }));
export default ChevronDown;
